import HeaderBar from "./HeaderBar";
import NavigationBar from "./NavigationBar";
import MobileBar from "./MobileBar";

const Header = () => {
  return (
    <header>
      <HeaderBar />
      <NavigationBar />
      <MobileBar />
    </header>
  );
};

export default Header;
